module.exports = __webpack_public_path__ + "static/img/client-5.2a076b4f.png";